var map = {
	"./fonts/1001fonts-technology-eula.txt": 5914,
	"./fonts/Movie Poster Personal Use.ttf": 20,
	"./fonts/Technology-Bold.ttf": 8135,
	"./fonts/Technology-BoldItalic.ttf": 9970,
	"./fonts/Technology-Italic.ttf": 2646,
	"./fonts/Technology.ttf": 8690,
	"./icons/hamburger-menu.png": 2620,
	"./images/Angelo.webp": 4030,
	"./images/angelo-foreman.jpg": 8804,
	"./images/belt.png": 3520,
	"./images/canelo.png": 2902,
	"./images/ggg.png": 9776,
	"./images/kafka.webp": 136,
	"./images/loading.gif": 9163,
	"./images/lomachenko.png": 9696,
	"./images/mayweathersr.png": 8021,
	"./images/mobile_splash.png": 8756,
	"./images/pacquiao.png": 5378,
	"./images/readme/congrats.png": 9243,
	"./images/readme/pads.png": 7881,
	"./images/readme/workout settings2.PNG": 7003,
	"./images/rendell.png": 2578,
	"./images/tyson.png": 779,
	"./logos/abc_logo.png": 9085,
	"./logos/logo.png": 5379,
	"./sounds/bell1.wav": 664,
	"./sounds/bell2.wav": 2160,
	"./sounds/bell3.wav": 8586,
	"./sounds/clicker1.wav": 3740,
	"./sounds/credits": 7641,
	"./sounds/door-knock-6406.mp3": 2895,
	"./sounds/hit1.mp3": 6835,
	"./sounds/hit1.wav": 8095,
	"./sounds/hit2.wav": 2831,
	"./sounds/hit3.wav": 7244,
	"./sounds/hit4.wav": 6495,
	"./sounds/hit5.wav": 3479,
	"./sounds/hit6.wav": 9164,
	"./sounds/hit7.wav": 5586,
	"./sounds/hit8.wav": 4391,
	"./sounds/hit9.wav": 5009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;